

/** Config interface */
export interface SocketIoConfig {
    url: string;
    options?: any;
};


// WEBPACK FOOTER //
// ./node_modules/ng-socket-io/socketIoConfig.ts